/* @flow weak */
export default function(email) {
  return /\S+@\S+\.\S+/.test(email);
}



// WEBPACK FOOTER //
// ./src/lib/isEmail.js